import { z } from "zod";
/** RFC 9457 problem details, as every API error is returned. */
export const Problem = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    code: z.string(),
    instance: z.string().optional(),
    errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
//# sourceMappingURL=problem.js.map